<template>
  <div class="pop-mask">
    <div class="pop-body">
      <div class="pop-close" @click="quitClose">
        <img src="../../assets/image/trade_insert_close.png">
      </div>
      <div class="pop-box">
        <Form ref="tradeBean" :model="tradeBean" :rules="ruleBean" :label-width="115">
          <FormItem label="商品标题 :" prop="trade_title">
            <Input size="large" v-model="tradeBean.trade_title" style="width: 270px;" placeholder="请输入商品标题"></Input>
          </FormItem>
          <FormItem label="游戏名 :" prop="trade_gid">
            <Select size="large" v-model="tradeBean.trade_gid" style="width: 270px;"
             placeholder="请选择角色所在游戏" @on-change="queryServiceList()">
              <Option :value="item.id" v-for="item in gameList" :key="item.id">{{item.text}}</Option>
            </Select>
          </FormItem>
          <FormItem label="游戏服务器 :" prop="trade_sid">
            <Select size="large" v-model="tradeBean.trade_sid" style="width: 270px;"
              placeholder="请选择角色所在区服" @on-change="queryRole">
              <Option :value="item.id" v-for="item in serviceList" :key="item.id">{{ item.text }}</Option>
            </Select>
          </FormItem>
          <div class="pop-item" style="margin-bottom: 20px;" prop="trade_rid" 
            v-model="tradeBean.trade_rid">
            <p class="pop-p">
              <span><i>*</i> 充值金额 :</span>
              <span style="margin-left: 15px;">{{roleInvest}}</span>
            </p>
          </div>
          <FormItem label="商品图片 :" prop="trade_images" style="height: 100px;">
            <div class="demo-upload-list" v-for="item in uploadList">
              <template v-if="item.status === 'finished'">
                <Img :src="baseAddress+item.url" fit="cover" width="100%" height="100%"></Img>
                <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" @click="handleView(item.url)"></Icon>
                  <Icon type="ios-trash-outline" @click="handleRemove(item)"></Icon>
                </div>
              </template>
            </div>
            <Upload ref="upload" :show-upload-list="false"
              :on-success="handleSuccess" :format="['jpg','jpeg','png']" :max-size="3072"
              :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize"
              :before-upload="handleBeforeUpload"
              multiple type="drag" :action="baseAddress+'upload_trade_picture'"
              style="display: inline-block;height: 80px;width: 80px;">
              <div style="width: 80px;height: 80px;line-height: 80px;">
                <Icon type="ios-add" size="20"></Icon>
              </div>
            </Upload>
          </FormItem>
          <div class="pop-hint">
            单张图片需要小于3M,最多上传5张,支持jpg格式。上传装备属性等800X800以上图片,买家购买时可大图查看,更利于出售
          </div>
          <FormItem label="商品卖点描述 :" prop="trade_selling">
            <Input v-model="tradeBean.trade_selling" type="textarea" placeholder="信息反应游戏账号角色真实战力、神器装备、强力属性等相关的描述,50字以内。"></Input>
          </FormItem>
          <FormItem label="二级密码(有则必填) :">
            <Input v-model="tradeBean.trade_password" type="textarea" placeholder="商会/仓库密码,仅审核人员及小号购买者可见"></Input>
          </FormItem>
          <FormItem label="商品价格 :" prop="trade_sole">
            <Input size="large" type="number" v-model="tradeBean.trade_sole" style="width: 270px;" placeholder="请输入商品价格"></Input>
            <span class="pop-unit">元</span>
          </FormItem>
          <div class="pop-money">
            <Icon type="ios-alert-outline" color="#ff8200" size="16"></Icon>
            20元 ≤ 单件售价 < 100万
          </div>
          <FormItem prop="trade_contract">
            <div class="pop-contract">
              <CheckboxGroup  v-model="tradeBean.trade_contract">
                <Checkbox>
                  <span>我已经详细阅读<a class="pop-a">《温馨提示》</a><a class="pop-a">《角色交易服务协议》</a>并充分了解。</span>
                </Checkbox>
              </CheckboxGroup>
            </div>
          </FormItem>
          <Button size="large" type="primary" @click="handleSubmit('tradeBean')" class="pop-submit">确定寄售</Button>
        </Form>
      </div>
    </div> 
    <div v-show="showPopState" class="pop-insert-body">
      <div class="header">
        <span class="title">交易预览图</span>
        <img class="close" src="../../assets/image/window_close_normal.png" alt="关闭" @click="closePop">
      </div>
      <img class="img" :src="tradeImg">
    </div> 
  </div>
</template>
<script>
export default {
  metaInfo(){
    return {
      title:"交易添加_"+this.$store.state.home.title,
      meta:[
        { name:'keywords', content:this.$store.state.home.keywords},
        { name:'description',content:this.$store.state.home.description}
      ]
    }
  },
  computed:{
    baseAddress(){
      return this.$store.state.constant.baseAddress;
    },
  },
  data(){
    return{
      tradeBean:{
        trade_title:'',
        trade_images:[],
        trade_selling:'',
        trade_gid:'',
        trade_sid:'',
        trade_rid:'',
        trade_password:''
      },
      roleInvest:0,
      roleState:false,
      uploadList:[],
      serviceList:[],
      gameList:[],
      ruleBean:{
        trade_title:[
          { required: true, message: '请输入商品标题', trigger: 'blur' },
          { type: 'string', min: 1, message: '至少输入1字描述', trigger: 'blur'},
          { type: 'string', max: 20, message: '最多输入20字描述', trigger: 'blur'}
        ],
        trade_rid:[
          { required: true, type: 'string', min: 1,message: '请获取角色信息'}
        ],
        trade_gid:[
          { required: true, message: '请选择角色所在游戏', trigger: 'change' },
        ],
        trade_sid:[
          { required: true, message: '请选择角色所在区服', trigger: 'change' },
        ],
        trade_images:[
          { required: true, type: 'array', min: 1, message: '至少上传1张预览图', trigger: 'change' },
          { type: 'array', max: 5, message: '最多上传5张预览图', trigger: 'change' }
        ],
        trade_selling:[
          { required: true, message: '请输入商品卖点描述', trigger: 'blur'},
          { type: 'string', min: 20, message: '至少输入20字描述', trigger: 'blur'},
          { type: 'string', max: 100, message: '最多输入100字描述', trigger: 'blur'}
        ],
        trade_sole:[
          { required: true, message: '请输入商品价格', trigger: 'blur'},
          { type: 'number', min: 20, message: '商品价格不能低于20元', trigger: 'blur', transform(value){return Number(value);}},
          { type: 'number', max: 1000000, message: '商品价格不能高于100万元', trigger: 'blur',  transform(value){return Number(value);}}
        ],
        trade_contract:[
          { required: true, type:'array',min: 1, message: '请先阅读协议', trigger: 'change'},
        ]
      },
      tradeImg:"",
      showPopState:false
    }
  },
  components: {
  },
  methods:{
    queryRole(){
      if(this.tradeBean.trade_gid.length <= 0){
        alert("请选择角色所在游戏!");
        return;
      }
      if(this.tradeBean.trade_sid.length <= 0){
        alert("请选择角色所在区服!");
        return;
      }
      this.$http.post('/query_trade_role?gid='+this.tradeBean.trade_gid+
        '&sid='+this.tradeBean.trade_sid)
        .then(res=>{
          if(res.data.code == 2000){
            var role = res.data.data;
            this.tradeBean.trade_rid = role.game_role_out_uid;
            this.roleInvest = role.game_role_invest;
            this.roleState = false;
          }else{
            this.roleState = true;
            alert(res.data.msg);
          }
        })
    },
    quitClose(){
      this.$emit('quitClose',false);
    },
    quitHandle(){
      this.$emit('quitHandle');
    },
    queryGameList(){
      this.$http.post('/query_trade_game_list')
      .then(res=>{
        if(res.data.code == 2000){
          this.gameList = res.data.data;
        }else{
          this.gameList = [];
        }
      })
    },
    closePop(){
      this.showPopState = false;
    },
    queryServiceList(){
      this.$http.post(`/query_trade_service_list?gid=`+this.tradeBean.trade_gid)
        .then(res=>{
        if (res.data.code == 2000) {
          this.serviceList = res.data.data;
        }else{
          this.serviceList = [];
        }
      })
    },
    handleSubmit(name){
      if(this.roleState){
        alert("该角色正在交易中,请选择其他角色!");
        return;
      }
      this.$refs[name].validate((valid) =>{
        if(valid){
          this.$http.post("/add_trade_role",{
            data:this.tradeBean
          }).then(res=>{
            if(res.data.code == 2000){
              alert("角色售卖成功!");
              this.tradeBean.trade_title = null;
              this.tradeBean.trade_gid = null;
              this.tradeBean.trade_sid = null;
              this.tradeBean.trade_rid = null;
              this.tradeBean.trade_sole = null;
              this.tradeBean.trade_selling = null;
              this.tradeBean.trade_password = null;
              this.tradeBean.trade_images = {};
              this.quitHandle();
            }else{
              alert(res.data.msg);
            }
          });
        }else{
          alert("请先写完交易信息!");
          return;
        }
      });
    },
    handleRemove(file){
      this.uploadList.splice(this.uploadList.indexOf(file),1);
      this.tradeBean.trade_images.splice(this.tradeBean.trade_images.indexOf(file.name),1);
    },
    handleView(url){
      this.tradeImg = this.baseAddress+url;
      this.showPopState = true;
    },
    handleSuccess(res,file){
      file.url = res.data.file_address;
      file.name = res.data.file_name;
      this.uploadList.push(file);
      this.tradeBean.trade_images.push(file.name);
    },
    handleFormatError(file){
      this.$Notice.warning({
        title:"文件格式提示",
        desc: file.name+"图片格式错误,请选择jpg和png!"
      })
    },
    handleMaxSize(file){
      this.$Notice.warning({
        title:"图片大小限制",
        desc:"图片 "+file.name+"太大,超过3M!"
      })
    },
    handleBeforeUpload(){
      const check = this.uploadList.length < 5;
      if(!check){
        this.$Notice.warning({
          title: '上传图片不能超过5张!'
        });
      }
      return check;
    }
  },
  mounted(){
    this.queryGameList();
  }
}
</script>
<style src="@/assets/css/trade/trade_insert.css" scoped></style>